
export class RateItem {

  /**
   * Unique identifier for the rate card answer.
   */
  id?: string | null;

  /**
   * Gets or sets if this is an edit item. I.e. has been created, modified by a user and not yet saved to the live data.
   */
  isEditItem?: boolean | null;

  /**
   * Gets or sets if this item is marked for deletion.
   */
  isDeletion?: boolean | null;

  /**
   * Identifier for the deal item associated with this rate card answer.
   */
  dealItemId?: string | null;

  /**
   * Gets or sets the time segment.
   */
  timeSegment?: number | null;

  /**
   * Current status of the rate card answer, represented as an integer.
   */
  status?: number | null;
  
  /**
   * Index indicating a failure in categorization of the rate card answer, if applicable.
   */
  idxFail?: number | null;

  /**
   * Description or additional information about the rate card answer.
   */
  desc?: string | null;

  /**
   * Sort order for the rate card answer.
   */
  sortOrder?: number | null;

  /**
   * Lookup index for the first category index.
   */
  idx1?: string | null;

  /**
   * Lookup index for the second category index.
   */
  idx2?: string | null;

  /**
   * Lookup index for the third category index.
   */
  idx3?: string | null;

  /**
   * Lookup index for the fourth category index.
   */
  idx4?: string | null;

  /**
   * Lookup index for the fifth category index.
   */
  idx5?: string | null;

  /**
   * Lookup index for the sixth category index.
   */
  idx6?: string | null;

  /**
   * Lookup index for the seventh category index.
   */
  idx7?: string | null;

  /**
   * Lookup index for the eighth category index.
   */
  idx8?: string | null;

  /**
   * Lookup index for the ninth category index.
   */
  idx9?: string | null;

  /**
   * Lookup index for the tenth category index.
   */
  idx10?: string | null;

  /**
   * Factor applied to convert prices to an annual basis.
   */
  anFactor?: number | null;

  /**
   * Quantity of the item or service in question for the rate card answer.
   */
  quantity?: number | null;
  
  /**
 * Customer unit price for the rate card answer.
 */
  customerUnPrice?: number | null;

  /**
   * Lower percentile price for the unit.
   */
  percUnL?: number | null;

  /**
   * Target price for the unit.
   */
  percUnT?: number | null;

  /**
   * Higher percentile price for the unit.
   */
  percUnH?: number | null;

  /**
   * delta from the customer to target unit price.
   */
  deltaUn?: number | null;

  /**
   * delta from the customer to the target unit as a percentage.
   */
  deltaUnP?: number | null;

  /**
   * total customer price incl. quantity.
   */
  customerPrice?: number | null;

  /**
   * total lower percentile price
   */
  percL?: number | null;

  /**
   * total target percentile price.
   */
  percT?: number | null;

  /**
   * total higher percentile price
   */
  percH?: number | null;

  /**
   * delta from the total customer to total target 
   */
  delta?: number | null;

  /**
   *  delta from the total customer to total target as a percentage.
   */
  deltaP?: number | null;

  /**
   * Level of confidence in the data provided.
   */
  confidenceLevel?: string | null;

  /**
   * XML string containing custom columns, allowing for extensibility and customization of data.
   */
  customColumnsXML?: string | null;

  /**
   * Display value for the first category index
   */
  idxVal1?: string | null;

  /**
   * Display value for the second category index.
   */
  idxVal2?: string | null;

  /**
   * Display value for the third category index.
   */
  idxVal3?: string | null;

  /**
   * Display value for the fourth category index.
   */
  idxVal4?: string | null;

  /**
   * Display value for the fifth category index.
   */
  idxVal5?: string | null;

  /**
   * Display value for the sixth category index.
   */
  idxVal6?: string | null;

  /**
   * Display value for the seventh category index.
   */
  idxVal7?: string | null;

  /**
   * Display value for the eighth category index.
   */
  idxVal8?: string | null;

  /**
   * Display value for the ninth category index.
   */
  idxVal9?: string | null;

  /**
   * Display value for the tenth category index.
   */
  idxVal10?: string | null;

  /**
   * Optional, handshake identifier set by the client.
   * Used to identify the client's rate item when sending new data to the API where a database identifier is not yet available.
  */
  clientId?: string | null;
  
  /**
   * Confidence score
   */
  confidenceScore?: number | null;

  /**
   * BLENDED GROUP 
   */
  blendedGroup?: string | null;

  /**
   * percentage allocation 
   */
  pcertAllocation?: number | null;

  /**
   * custom adjustment 
   */
  customAdj?: number | null;

  /**
   * custom adjustment 
   */
  dailyHrs?: number | null;
  /**
   * ratetable - required while defining blended rates 
   */
  rateTable?: string | null;

  /**
   * reset the value of the calculations
   */
  public resetCalculations() {

    this.percUnL = null;
    this.percUnT = null;
    this.percUnH = null;
    this.deltaUn = null;
    this.deltaUnP = null;
    this.customerUnPrice = null;

    this.percL = null;
    this.percT = null;
    this.percH = null;
    this.delta = null;
    this.deltaP = null;
    this.customerPrice = null;
    
    this.confidenceLevel = null;
    this.confidenceScore = null;
  }
}




